import React,{useState} from "react";
import "./App.css";
import Feed from "./components/Feed";
import Header from "./components/Header";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import Widget from "./components/Widget";
const App = () => {
  const [islogin, setIsLogIn]=useState(false);
  const [userdata, setUserdata] = useState({
    name:"",
    photoUrl:"",
    email:"",
    password:"",
    signup:false

  });

  return (
    <>
      {!islogin ? (
        <Login  setIsLogIn={setIsLogIn} userdata={userdata} setUserdata={setUserdata}/>
      ) : (
        <div id='app__wrapper'>
          <Header userdata={userdata}/>
          <div className='app__body'>
            <Sidebar userdata={userdata}/>
            <Feed userdata={userdata}/>
            <Widget />
          </div>
        </div>
      )}
    </>
  );
};

export default App;